<template>
  <div id="toutiao-add-plan-template">
    <div class="main-wrapper">
      <div class="block-title">
        <el-badge value="new">
          <h2 class="title-name">{{ props.isV3 ? '巨量引擎智擎版' : '巨量引擎2.0' }}</h2>
        </el-badge>

        <div class="btns">
          <el-button class="btn config-btn" @click="showSettingsModal">批量方案配置 </el-button>
          <TemplateManagement :template-json="selectedTemplateInfo" @confirm="onTemplateSelectConfirm" />
        </div>
      </div>
      <div class="block-main" v-loading="onTemplateSelectLoading">
        <MediaAccountSelector @setValue="onMediaAccountSelectConfirm" />
        <div class="config-cols">
          <el-row :gutter="12">
            <el-col :span="4">
              <ProjectConfigCol :ref="(el) => (formColRefs[0] = el)" title="项目基础信息"></ProjectConfigCol>
            </el-col>
            <el-col :span="4"> <TargetingConfigCol title="投放版位/定向包"></TargetingConfigCol> </el-col>
            <el-col :span="4"> <PlanInfoConfigCol :ref="(el) => (formColRefs[1] = el)" title="计划信息"></PlanInfoConfigCol> </el-col>
            <el-col :span="8"> <CreativeConfigCol :ref="(el) => (formColRefs[2] = el)" title="创意素材"></CreativeConfigCol> </el-col>
            <el-col :span="4">
              <div class="vertical-block">
                <DescriptionConfigCol class="desc" title="文案包"></DescriptionConfigCol>
                <LandingPageConfigCol class="landingpage" title="落地页包"></LandingPageConfigCol>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="footer">
        <div class="plans-desc">
          <div class="col" v-for="(num, key) in displayPlanNums" :key="key">
            <p>{{ key }}</p>
            <p>{{ num }}</p>
          </div>

          <div class="result">
            <p>生成计划数量</p>
            <p>
              {{ generateTotalNum }}
            </p>
          </div>
        </div>

        <div class="preview-btn">
          <el-button type="primary" @click="validateAndMakePreviewTable">预览计划</el-button>
        </div>
      </div>

      <div class="preview-table" v-if="Object.values(previewOriginData).length">
        <div class="preview-table-header">
          <div class="accounts">
            <el-tag
              v-for="(account, index) in configForm.accounts"
              :key="account.id"
              :type="activeAccount === account.id ? '' : 'info'"
              @click="activeAccount = account.id"
            >
              <span> 账号{{ index + 1 }}：{{ account.adAccount }}</span>
              <span> ({{ getPlanCountsByAccountId(account) }}) </span>
            </el-tag>
          </div>
          <el-button type="primary" @click="onSubmitValidate">提交选中计划</el-button>
        </div>
        <PreviewTable
          :active-account="activeAccount"
          :table-data="tableData"
          :targetings="targetPackages"
          :creatives="creativeGroups"
          :table-form="tableFormFilteredByAccount"
          @update-table-data="updateTableData"
          @update-table-form="updateTableForm"
        >
          <template v-slot:projectName="slotProps">
            <div class="project-name">
              <el-input
                v-model="slotProps.row.campaign_params.project_name"
                @input="onProjectNameInput($event, slotProps.row, slotProps.$index)"
                placeholder="请输入项目信息"
              ></el-input>
              <p class="project-name-error-msg">
                <span v-if="!slotProps.row.campaign_params.project_name">项目名称不能为空</span>
                <span v-else-if="duplicateProjectNameError === slotProps.row.campaign_params.project_name">项目名称不能重复</span>
              </p>
            </div>
          </template>

          <template v-slot:planName="slotProps">
            <el-input
              v-model="slotProps.row.inner_plan_params.plan_name"
              v-if="slotProps.editable"
              @input="onPlanNameInput($event, slotProps.row, slotProps.$index)"
              placeholder="请输入计划名称"
            ></el-input>
            <!-- 广告是项目广告时不能被修改 -->
            <span v-else> {{ slotProps.row.inner_plan_params.plan_name }} </span>
            <p class="project-name-error-msg">
              <span v-if="!slotProps.row.inner_plan_params.plan_name">计划名称不能为空</span>
              <span v-else-if="duplicatePlanNameError === slotProps.row.inner_plan_params.plan_name">计划名称不能重复</span>
            </p>
          </template>
        </PreviewTable>
      </div>
    </div>
    <BatchPlanConfigModal ref="ref_BatchPlanModal" @setValue="onTemplateConfigConfirm" />

    <p class="bottom-gap"></p>

    <el-dialog
      title="提交计划确认"
      :visible.sync="submitConfirmModal"
      :close-on-click-modal="false"
      custom-class="before-submit-modal"
      style="margin-top: 22vh"
      width="360px"
    >
      <el-form inline @submit.native.prevent>
        <el-form-item prop="name" label="模板名称">
          <el-input style="width: 100%" v-model.trim="submitSaveTemplateName" placeholder="请输入模板名称"></el-input>
          <p style="font-size: 12px">需保存模板名称时填写</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitCancel">取 消</el-button>
        <el-button type="primary" v-if="!!submitSaveTemplateName" :loading="submitLoading" @click="saveTemplateSubmit">
          保存模板后提交
        </el-button>
        <el-button type="primary" v-else :loading="submitLoading" @click="onSubmitConfirm">直接提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
// import store from '@/store'
import { ref, computed, provide, nextTick } from 'vue'
import { getCookie } from '@/common/js/api.js'
import { mergeDeep } from '@/common/js/utils.js'
import { pick } from '@/common/js/just.js'

import ProjectConfigCol from './components/project/index.vue'
import TargetingConfigCol from './components/targeting/index.vue'
import PlanInfoConfigCol from './components/plan/index.vue'
import CreativeConfigCol from './components/creative/index.vue'
import DescriptionConfigCol from './components/creative/description.vue'
import LandingPageConfigCol from './components/creative/landingpage.vue'
import BatchPlanConfigModal from './components/batchPlan/index.vue'
import MediaAccountSelector from './components/account/index.vue'
import TemplateManagement from './components/template/index.vue'
import PreviewTable from './components/preview-table/index.vue'

import { usePlanDistribute } from './hooks/useToutiaoPlansPreview.js'
import { useTemplateManage } from './hooks/useToutiaoPlanTemplates.js'

import { getProjectFormModel, getCreativeFormModel, getPlanFormModel, getConfigFormModel } from './model/form.js'

// eslint-disable-next-line
const props = defineProps({
  isV3: {
    type: Boolean,
    default: false
  }
})

const opId = getCookie('ch_op_id')

const configForm = ref(getConfigFormModel({ isV3: props.isV3 }))

const updateConfigForm = (form) => {
  clearPreviewTable()
  configForm.value = form
}

provide('configForm', {
  configForm,
  updateConfigForm
})

provide('bytedanceVersion', {
  isV3: computed(() => props.isV3)
})

provide('localStates', {
  opId: Number(opId),
  getGameId: () => configForm.value.project?.game?.id || null,
  getAdAccount: () => configForm.value.accounts[0] || null
})

window.addEventListener('beforeunload', function (event) {
  event.preventDefault()
  event.returnValue = '您有未保存的更改，确定要离开吗？'
  return '您有未保存的更改，确定要离开吗？'
})

const ref_BatchPlanModal = ref(null)
const showSettingsModal = () => {
  ref_BatchPlanModal.value.open()
}

const displayPlanNums = computed(() => {
  const nums = {}
  const { accounts, targetings, creatives, descriptions, template } = configForm.value
  const { adNumber, accountAllocation } = template
  const keys = []

  if (adNumber === 1 && accountAllocation === 1) keys.push('定向包', '素材组', '账号')
  // 按定向包分配
  if (adNumber === 2 && accountAllocation === 2) {
    if (targetings.length >= accounts.length) keys.push('定向包', '素材组')
    else {
      keys.push('素材组', '账号')
    }
  }
  if (adNumber === 3 && accountAllocation === 2) keys.push('素材组')
  if (adNumber === 3 && accountAllocation === 3) keys.push('素材组')

  nums['定向包'] = targetings.length
  nums['素材组'] = creatives.length
  // nums['文案包'] = descriptions.length
  nums['账号'] = accounts.length

  return pick(nums, keys)
})
const generateTotalNum = computed(() => {
  const arr = Object.values(displayPlanNums.value)
  if (!arr.length) return 0
  return arr.reduce((acc, c) => acc * c, 1)
})

const {
  formColRefs,
  duplicateProjectNameError,
  duplicatePlanNameError,
  activeAccount,
  submitLoading,
  submitConfirmModal,
  submitSaveTemplateName,
  previewOriginData,
  tableData,
  tableStatesForm,
  targetPackages,
  creativeGroups,
  tableFormFilteredByAccount,
  updateTableData,
  updateTableForm,
  onPlansValidate,
  onPlansPreview,
  onSubmitValidate,
  duplicateNameValidate,
  onSubmitCancel,
  onSubmitConfirm,
  saveTemplateSubmit
} = usePlanDistribute(configForm)

const { onTemplateSelectLoading, selectedTemplateInfo, onTemplateConfirm } = useTemplateManage(configForm)

function getPlanCountsByAccountId(account) {
  const data = previewOriginData.value[account.id] || []
  const checkedCounts = data.filter((i) => i.isCheck !== false).length
  const totalCounts = data.length
  return `${checkedCounts}/${totalCounts}`
}

function onProjectNameInput(project_name, row, index) {
  // 修改项目下全部广告的项目名称
  const newData = tableData.value.map((i) => {
    if (i.temp_project_name === row.temp_project_name) {
      i.campaign_params.project_name = project_name
      return i
    }
    return i
  })
  // 每个项目组的第一个广告名称修改为与项目名称一致，index可以保证为每个项目下的第一个广告
  newData[index].inner_plan_params.plan_name = project_name
  updateTableData(newData)
  nextTick(duplicateNameValidate)
}

function onPlanNameInput(planName, row, index) {
  const newData = tableData.value.map((i, rowIndex) => {
    if (rowIndex === index) {
      i.inner_plan_params.plan_name = planName
    }
    return i
  })

  updateTableData(newData)
  nextTick(duplicateNameValidate)
}

async function validateAndMakePreviewTable() {
  try {
    await onPlansValidate()
    onPlansPreview()
  } catch (e) {
    console.log('e.message output: ', e.message)
    // 如果存在未通过校验的表单，打开表单配置弹窗
    const { index } = JSON.parse(e.message)
    if (index > -1) {
      formColRefs.value[index].openInvalidFormDrawer()
    }
  }
}

/**
 * @description: 选取模板
 */
async function onTemplateSelectConfirm(row) {
  configForm.value = {
    ...(await onTemplateConfirm(row)),
    isV3: props.isV3
  }

  // 选择模板更新批量方案配置
  ref_BatchPlanModal.value.updateConfig(configForm.value.template)

  // 清空预览表格
  previewOriginData.value = {}
}

function onTemplateConfigConfirm(data) {
  configForm.value.template = data
  clearPreviewTable()
}

function clearPreviewTable() {
  previewOriginData.value = {}
}

function onMediaAccountSelectConfirm(data) {
  configForm.value.accounts = data
  const tableStates = {}
  data.forEach((account) => {
    tableStates[account.id] = {
      projectSwitch: true,
      planSwitch: true,
      isCheckAll: true
    }
  })

  tableStatesForm.value = tableStates
}
</script>
<style scoped lang="scss">
#toutiao-add-plan-template {
  height: 100vh;
  padding: 16px;
  margin-bottom: 0;
  overflow: auto;
  ::v-deep .el-tag--info {
    color: #666;
    cursor: pointer;
  }
  ::v-deep .el-table .el-table__header-wrapper th .cell {
    color: #333;
  }
  .main-wrapper {
    min-width: 1600px;
    background: #fff;
    padding: 16px;

    .block-title {
      display: flex;
      align-items: center;
      .title-name {
        font-size: 18px;
        font-weight: 600;
      }

      .btns {
        margin-left: 32px;
        flex: 1;
        display: flex;
        justify-content: space-between;
        .btn {
          font-size: 14px;
        }
        .config-btn {
          background: #ebedf0;
          color: #000;
        }
      }
    }

    .block-main {
      .top-form {
        margin-top: 10px;
      }

      .config-cols {
        height: 758px;
        .vertical-block {
          display: flex;
          flex-direction: column;

          .landingpage {
            margin-top: 10px;
          }
        }

        ::v-deep .block-title {
          display: flex;
          align-items: flex-end;
          h4 {
            color: #000;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
          }
          > span {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 12px;
    border-top: 1px solid #eee;
    background-color: #fff;
    min-width: 1600px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .plans-desc {
      margin-right: 56px;
      display: flex;
      align-items: center;
      .col,
      .result {
        position: relative;
        margin-right: 40px;
        p:first-child {
          margin-bottom: 10px;
        }
        p:last-child {
          font-weight: 600;
          font-size: 14px;
          text-align: center;
        }
      }
      .col {
        &:not(:first-child)::after {
          content: '×';
          color: #bbb;
          position: absolute;
          left: -26px;
          top: 40%;
          margin-top: -8px;
          font-size: 20px;
        }
      }

      .result {
        margin-right: 0;
        &::after {
          content: '=';
          color: #bbb;
          position: absolute;
          left: -26px;
          top: 50%;
          margin-top: -8px;
          font-size: 18px;
        }
      }
    }
    .preview-btn {
      button {
        background: #1974ff;
        margin: 0 !important;
      }
    }
  }

  .preview-table {
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 12px;
    .preview-table-header {
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .accounts {
        .el-tag {
          margin-right: 10px;
        }
      }
    }

    .project-name-error-msg {
      color: red;
      margin-top: 2px;
    }
  }

  .bottom-gap {
    padding: 50px;
  }
}

::v-deep .before-submit-modal {
  .el-dialog__body {
    padding-bottom: 10px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
